import { Vector3 as p } from "three";
import { isVector3 as a } from "../three/index15.js";
import { rotateRawVector as m } from "./index22.js";
function V(t, o) {
  let r;
  const s = a(t);
  s ? r = [t.x, t.y, t.z] : r = t.slice();
  const e = o.rot.map((i) => i * Math.PI / 180);
  r = m(r, e);
  const n = [r[0] + o.pos[0], r[1] + o.pos[1], r[2] + o.pos[2]];
  return s ? new p().fromArray(n) : n;
}
export {
  V as applyTransform
};
//# sourceMappingURL=index2.js.map
